/**
 * Created by Ram on 15/09/2016.
 */

import React, { Component } from 'react'
import { navigate } from '@reach/router'
import AllCustomersInfo from '../presentation/all-customers-info';

let reloadTimer = null;

export default class AllCustomersInfoWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search          : this.props.search?this.props.search:'',
            accountType     : this.props.accountType?this.props.accountType:'all',
            sort            : this.props.sort?this.props.sort:'creationTime',
            sortAsc         : this.props.sortAsc == 'true',
            showDeleted     : this.props.showDeleted == 'true',
            customers       : []
        }
    }

    updateShowDeleted = e => {
        this.setState({showDeleted: e.target.checked});
    };

    updateSearchState = e => {
        this.setState({search: e.target.value});
    };

    updateAccountTypeState = e => {
        this.setState({accountType: e.target.value});
    };

    updateSortState= sortBy => {
        if (sortBy == this.state.sort) {
            this.setState({ sortAsc : !this.state.sortAsc });
        } else {
            this.setState({ sort : sortBy });
        }
    };

    loadNewQueryParams = () => {
        const { search, sort, sortAsc, showDeleted } = this.state
        navigate(`/allCustomers/${search}/${sort}/${sortAsc}/${showDeleted}`)
    }

    componentDidUpdate(prevProps, prevState) {
        if( prevState.search != this.state.search ) {
            if( reloadTimer ) {
                clearTimeout(reloadTimer);
                reloadTimer = null;
            }
            reloadTimer = setTimeout(() => {
                this.refreshList();
                this.loadNewQueryParams()
            }, 500);
        }
        if( prevState.sort != this.state.sort || prevState.sortAsc != this.state.sortAsc ) {
            if( reloadTimer ) {
                clearTimeout(reloadTimer);
                reloadTimer = null;
            }
            this.refreshList();
            this.loadNewQueryParams()
        }
        if( prevState.showDeleted != this.state.showDeleted ) {
            if( reloadTimer ) {
                clearTimeout(reloadTimer);
                reloadTimer = null;
            }
            this.refreshList();
            this.loadNewQueryParams()
        }
        if( prevState.accountType != this.state.accountType ) {
            if( reloadTimer ) {
                clearTimeout(reloadTimer);
                reloadTimer = null;
            }
            this.refreshList();
            this.loadNewQueryParams()
        }
    };

    componentWillMount() {
        this.refreshList();
    }

    handleSelectCustomer = id => {
        navigate(`/customer/${id}`)
    };

    handleCreateAccount = () => {
        navigate('/createAccount')
    };

    refreshList = () => {
        const { search, sort, sortAsc, showDeleted, accountType } = this.state
        const params = `search=${search}&sort=${sort}&sortAsc=${sortAsc}&showDeleted=${showDeleted}&accountType=${accountType}`;
        fetch("/service/accountList?"+params, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin'
        }).then((response) => {
            if( response.status != 200 ) {
                response.json().then((json) => {
                    this.handleError(json, this);
                    return;
                });
            } else {
                response.json().then((json) => {
                    this.loadList(json);
                });
            }
        });
    };

    loadList = data => {
        this.setState({customers: data});
    };

    render() {
        return (
            <AllCustomersInfo 
                updateSearchState={this.updateSearchState}
                updateAccountTypeState={this.updateAccountTypeState}
                updateSortState={this.updateSortState} 
                lookupState={this.state}
                updateShowDeleted={this.updateShowDeleted} 
                customers={this.state.customers} 
                handleSelectCustomer={this.handleSelectCustomer} 
                handleCreateAccount={this.handleCreateAccount} 
            />
        )
    }
}